import { useNavigate } from "react-router-dom";
import CphereHeaderLogo from "../components/CphereHeaderLogo";
import { useAdvertiser } from "../contexts/AdvertiserContext";
import { resolveVerticalDashboardConfig } from "../config/verticalDashboardConfig";
import "./CinemaAnalytics.css";
import "./RetailIntelligence.css";

const retailDashboardConfig = resolveVerticalDashboardConfig("retail");

const MODULES = [
  {
    title: "Shopper Intent",
    body:
      "Track signals that point to shopper intent, including qualified traffic, product exploration, search behavior, cart activity, and high-value audience response.",
  },
  {
    title: "Product / Menu Performance",
    body:
      "Organize demand indicators around product interest, menu engagement, category response, offer visibility, and creative themes that move shoppers closer to consideration.",
  },
  {
    title: "Store / Geo Performance",
    body:
      "Read delivery and response by market so store coverage, local demand, delivery behavior, and regional media pressure can stay aligned.",
  },
  {
    title: "Conversion & Order Signals",
    body:
      "Use site, cart, order, and conversion signals to separate broad browsing from shoppers showing stronger purchase or delivery intent.",
  },
  {
    title: "Creative & Offer Performance",
    body:
      "Evaluate which product messages, menu offers, promotions, formats, and placements are producing measurable response from commerce audiences.",
  },
  {
    title: "Recommended Optimizations",
    body:
      "Translate shopper, product, menu, delivery, geo, and conversion signals into budget, creative, and offer decisions for the next optimization cycle.",
  },
];

const RETAIL_OPERATIONS_TILES = [
  {
    title: "Menu",
    body:
      "Analyze item-level engagement, category demand, menu interaction, and product-level response signals.",
  },
  {
    title: "Inventory",
    body:
      "Track product availability, demand patterns, sell-through indicators, and inventory-driven campaign opportunities.",
  },
  {
    title: "Delivery",
    body:
      "Monitor delivery-zone performance, order behavior, fulfillment signals, and location-based demand.",
  },
];

function RetailIntelligence() {
  const navigate = useNavigate();
  const { selectedAdvertiserName } = useAdvertiser() || {};

  return (
    <div className="reports-dashboard retail-intelligence-page">
      <div className="reports-content retail-intelligence-content">
        <CphereHeaderLogo
          alt="Powered by Logo"
          className="retail-analysis-poweredby-logo"
          onClick={() => navigate("/dashboard")}
          style={{ cursor: "pointer" }}
        />

        <section className="retail-intelligence-hero">
          <div className="retail-intelligence-hero-copy">
            <div className="retail-intelligence-kicker">
              {selectedAdvertiserName || "Selected Advertiser"}
            </div>
            <h1 className="retail-intelligence-title">Retail Intelligence</h1>
            <p className="retail-intelligence-copy">
              Retail performance is organized around shopper intent, product
              demand, menu engagement, delivery behavior, and conversion signals.
              This view surfaces actionable insights across in-store and digital
              commerce environments.
            </p>
          </div>

          <div className="retail-intelligence-hero-media" aria-hidden="true">
            <img
              src={retailDashboardConfig.tileImage}
              alt=""
              className="retail-intelligence-hero-image"
              draggable={false}
            />
          </div>
        </section>

        <section className="retail-intelligence-grid" aria-label="Retail Intelligence modules">
          {MODULES.map((module) => (
            <article className="retail-intelligence-card" key={module.title}>
              <h2>{module.title}</h2>
              <p>{module.body}</p>
            </article>
          ))}
        </section>

        <section className="retail-operations-menu" aria-labelledby="retail-operations-menu-title">
          <div className="retail-operations-menu-header">
            <CphereHeaderLogo
              alt="Cphere logo"
              className="retail-operations-menu-logo"
              draggable={false}
            />
            <h2 id="retail-operations-menu-title">Retail Operations Menu</h2>
          </div>

          <div className="retail-operations-tile-grid">
            {RETAIL_OPERATIONS_TILES.map((tile) => (
              <button
                type="button"
                className="retail-operations-tile"
                key={tile.title}
                aria-label={`${tile.title} retail operations intelligence placeholder`}
              >
                <span className="retail-operations-tile-title">{tile.title}</span>
                <span className="retail-operations-tile-copy">{tile.body}</span>
              </button>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

export default RetailIntelligence;
